import React, { useEffect } from "react";
import { Navigate, useOutlet } from "react-router-dom";
import { Container } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { AppBar } from "../../layouts/AppBar";

export const ProtectedLayout = () => {
    const { token, logout } = useAuth();
    const outlet = useOutlet();

    useEffect(() => {
        const handleStorage = (event) => {
            if (event.key === "token" && event.newValue === "null" && event.oldValue !== "null") {
                const pathname = window.location.pathname;
                if (pathname !== "/") {
                    logout("Your account has been logged out of a session.");
                }
            }
        };

        window.addEventListener("storage", handleStorage);

        return () => {
            window.removeEventListener("storage", handleStorage);
        };
    }, [logout]);

    if (!token) {
        return <Navigate to="/" />;
    }

    return (
        <div>
            <AppBar
                pages={[
                    { label: "Dashboard", path: "dashboard", role: [1, 2, 3] },
                    { label: "Users", path: "users", role: [1] },
                    { label: "Groups", path: "groups", role: [1] },
                    { label: "Logs", path: "logs", role: [1] },
                ]}
            />
            <Container maxWidth="xl" sx={{ p: 0 }} md={{ p: 0 }}>
                {outlet}
            </Container>
        </div>
    );
};
